(() => {
  const controllers = new WeakMap();

  function init(scope = document) {
    scope.querySelectorAll('[data-faq]').forEach(faq => {
      if (faq.dataset.ready || controllers.has(faq)) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      controllers.set(faq, controller);
      const links = [...faq.querySelectorAll('[data-faq-link]')];
      links.forEach(link => link.setAttribute('data-no-smooth', ''));
      const panels = [...faq.querySelectorAll('[data-faq-panel]')];
      const panelById = new Map(panels.map(panel => [panel.dataset.faqPanel, panel]));
      const picker = faq.querySelector('[data-faq-picker]');
      const answerById = new Map([...faq.querySelectorAll('.vs-answer[id]')].map(answer => [answer.id, answer]));
      let selectedId;

      function select(id, moveFocus = false) {
        if (!panelById.has(id)) id = panels[0]?.dataset.faqPanel;
        if (!id) return;
        if (id !== selectedId) {
          panels.forEach(panel => { panel.hidden = panel.dataset.faqPanel !== id; });
          links.forEach(link => {
            if (link.dataset.faqLink === id) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          if (picker) picker.value = id;
          selectedId = id;
        }
        if (moveFocus) {
          const heading = panelById.get(id).querySelector('h2');
          if (heading) {
            heading.tabIndex = -1;
            heading.focus({ preventScroll: true });
          }
        }
      }
      const hashId = () => {
        try { return decodeURIComponent(location.hash.slice(1)); }
        catch { return ''; }
      };
      const followHistory = () => {
        const id = hashId();
        const answer = answerById.get(id);
        if (answer) {
          select(answer.closest('[data-faq-panel]')?.dataset.faqPanel);
          const heading = answer.querySelector('h3');
          if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
          answer.style.scrollMarginBlockStart = '110px';
          answer.scrollIntoView({ block: 'start', behavior: 'auto' });
        } else if (!id || panelById.has(id)) select(id);
      };
      const navigate = (id, moveFocus = false) => {
        const hash = '#' + id;
        if (location.hash !== hash) history.pushState(null, '', hash);
        select(id, moveFocus);
      };
      select();
      followHistory();
      faq.dataset.ready = 'true';
      window.addEventListener('hashchange', followHistory, options);
      window.addEventListener('popstate', followHistory, options);
      links.forEach(link => link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        navigate(link.dataset.faqLink, true);
      }, options));
      picker?.addEventListener('change', () => navigate(picker.value), options);
    });
    const params = new URLSearchParams(location.search);
    if (params.get('request') === 'terms') {
      const page = scope.querySelector('[data-support-page]');
      if (page) {
        page.querySelector('h1').textContent = page.dataset.termsTitle;
        const message = page.querySelector('textarea');
        if (message && !message.value) message.value = page.dataset.termsMessage;
      }
    }
    scope.querySelector('[data-support-errors], [data-support-success]')?.focus({ preventScroll: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-faq]').forEach(faq => {
      controllers.get(faq)?.abort();
      controllers.delete(faq);
      delete faq.dataset.ready;
    });
  });
})();
